export const BOOKINGS_ROUTE_PREFIX: string = '/dashboard/bookings';

interface BookingsRoutes {
  index: {
    getUrl: (scopeSlug?: string) => string;
    path: string;
    relativePath: string;
  };
}

const bookingsRoutes: BookingsRoutes = {
  index: {
    path: `${BOOKINGS_ROUTE_PREFIX}/:scope?`,
    getUrl: (scopeSlug?: string): string => {
      if (!scopeSlug) {
        return BOOKINGS_ROUTE_PREFIX;
      }

      return `${BOOKINGS_ROUTE_PREFIX}/${scopeSlug}`;
    },
    relativePath: 'bookings/:scope?'
  }
};

export default bookingsRoutes;
